import React, { useEffect, useState } from 'react';
import { useGlobalContext } from '../../context';
import api from '../../api';
import SideNav from '../components/SideNav';
import { GiHamburgerMenu } from "react-icons/gi";
import { BiLogOut } from "react-icons/bi";
import { FiUsers, FiClock } from "react-icons/fi";
import adminDashLinks from './adminDashLinks';

const AdminDash = () => {
  const { allUsersMongoData, allUsersWithData } = useGlobalContext();
  const [pendingWithdrawals, setPendingWithdrawals] = useState([]);
  const [navActive, updateNavActive] = useState(null);

  const clearSess = async () => {
    try { await api.post('/api/logout'); } catch (e) {}
    window.sessionStorage.clear();
  };

  const hideNav = () => updateNavActive(false);

  useEffect(() => {
    if (navActive) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [navActive]);

  useEffect(() => {
    const pending = allUsersWithData.filter(
      (t) => t.withdrawstatus === 'Pending'
    );
    setPendingWithdrawals(pending);
  }, [allUsersWithData]);

  const cards = [
    {
      label: "Active Users",
      icon: <FiUsers className="text-[14px] text-[#A9ABAD]" />,
      value: allUsersMongoData.length,
      sub: "Registered accounts",
    },
    {
      label: "Pending Withdrawals",
      icon: <FiClock className="text-[14px] text-[#A9ABAD]" />,
      value: pendingWithdrawals.length,
      sub: "Awaiting approval",
    },
  ];

  return (
    <div className="absolute overflow-x-hidden w-full min-h-full text-white bg-black">
      <SideNav
        hideNav={hideNav}
        logout="/signin"
        logoutBtn={clearSess}
        translateAction={navActive ? `translate-x-[0px]` : `translate-x-[-500px]`}
        backgroundColor="bg-black"
        iconBorderColor="border-black"
        iconBgColor="bg-inherit"
        textColor="text-white"
        links={adminDashLinks}
        logouticon={
          <BiLogOut className="cursor-pointer text-[20px] text-white transition-all ease-in duration-300 hover:scale-[1.1]" />
        }
      />

      {navActive && (
        <div
          className="fixed inset-0 bg-black/60 z-40 xl:hidden"
          onClick={hideNav}
        />
      )}

      <div className="relative w-full h-full px-4 mb-[100px] xl:pl-[304px] xl:pr-6">
        {/* top nav */}
        <nav className="relative w-full min-h-[100px] flex justify-center items-start pt-3">
          <div className="relative w-full min-h-[50px] flex justify-between items-center xl:justify-end">
            <button onClick={() => updateNavActive(true)} className="relative xl:hidden">
              <GiHamburgerMenu className="text-[20px] text-[#A9ABAD]" />
            </button>
          </div>
        </nav>

        {/* page header */}
        <div className="relative w-full flex flex-col justify-start items-start space-y-1 pt-4 pb-8">
          <h3 className="text-[20px] font-[600] text-white">Admin Dashboard</h3>
          <p className="text-[#A9ABAD] text-[14px]">Overview of platform activity.</p>
        </div>

        {/* stat cards */}
        <div className="w-full grid grid-cols-1 gap-4 ssm:grid-cols-2">
          {cards.map((card) => (
            <div
              key={card.label}
              className="relative w-full bg-[#181C26] border border-[#1f2535] rounded-xl p-5 flex flex-col justify-between min-h-[130px]"
            >
              <div className="w-full flex justify-between items-center">
                <div className="flex items-center space-x-2">
                  {card.icon}
                  <p className="text-[12px] text-[#A9ABAD] uppercase tracking-widest font-[500]">
                    {card.label}
                  </p>
                </div>
                {card.sub && (
                  <span className="text-[11px] text-[#535963]">{card.sub}</span>
                )}
              </div>
              <div className="flex items-end justify-between mt-4">
                <p className="text-[22px] font-[600] text-white tracking-wide">
                  {card.value}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AdminDash;
